type CookieData = Cookie | string | (string | Cookie)[];
export type Info = {
	expires?: Date,
	secure?: boolean,
	cookie?: boolean,
	value: string,
	[key: string]: any,
}
export default class Cookie {
	_cookie: { [key: string]: Info }
	constructor(cookie?: CookieData) {
		this._cookie = {};
		this.add(cookie);
	}
	add(c?: CookieData) {
		//数组
		if (Array.isArray(c)) {
			return c.map(c => this.add(c))
		}
		//Cookie对象
		if (c instanceof Cookie) {
			return this.merge(c);
		}
		//字符串
		if (typeof c !== 'string') {
			return ;
		}
		//分割
		const info: string[] = c.split(/; */);
		//获取主要信息
		let main: string = info[0];
		info.shift();
		let name: string = '', value: string = '';
		let k:number = main.indexOf('=');
		if (k === -1) {
			name = decodeURIComponent(main);
		} else {
			name = decodeURIComponent(main.substr(0, k));
			value = decodeURIComponent(main.substr(k + 1));
		}
		let cookie: Info = this._cookie[name] = {value: ''};
		//参数获取
		info.map(info => {
			let i = info.indexOf('=');
			let k: string = '', v: string = '';
			if (i === -1) {
				k = decodeURIComponent(info.toLowerCase());
			} else {
				v = decodeURIComponent(info.substr(i + 1));
				k = decodeURIComponent(info.substr(0, i).replace(/ /g, '').toLowerCase());
			}
			cookie[k] = v;
		});
		//特殊参数处理
		if ('expires' in cookie) {
			const date = cookie.expires = new Date(cookie.expires as Date);
			if (date < new Date()) {
				return;
			}
		}
		if ('secure' in cookie) {
			cookie.secure = true;
		}
		if ('httponly' in cookie) {
			cookie.httponly = true;
		}
		cookie.value = value;
	}
	/**
	 * 添加cookie
	 */
	merge(c: Cookie) {
		if (typeof c === 'string') {
			return this.add(c);
		}
		if (c instanceof Cookie) {
			let cookie = c._cookie;
			for (let k in cookie) {
				this._cookie[k] = cookie[k];
			}
		}
	}
	/**
	 * 转到字符串
	 */
	toString() {
		let cookie = this._cookie;
		let list: string[] = [];
		for (let k in cookie) {
			let v = cookie[k];
			if ('expires' in v && (v.expires as Date) < new Date) {
				continue;
			}
			list.push(encodeURIComponent(k) + '=' + encodeURIComponent(v.value));
		}
		return list.join('; ');
	}

}
